<template>
  <div
    class="trainer-ranges traranges"
    :class="[
      { 'traranges_learning-mode': learningMode || skeleton },
      { 'traranges_single-table': hasHeroStrategy },
    ]"
  >
    <div
      class="traranges_player-container"
      :class="heroLeft ? 'order_1' : 'order_3 traranges_table-title_right'"
    >
      <div class="traranges_table-container traranges_table_left">
        <div
          class="traranges_table_title gw_hvr"
          :data-tst="`trainerRangesTable_hero_title`"
          @click="$emit('hero:click')"
        >
          {{ !hero.position ? '' : $t(`players.${hero.position}`) }}
          <i
            v-show="hero.position"
            class="mdi mdi-crown ml-1"
          ></i>
          <div
            class="d-flex align-center ml-auto"
            style="gap: 0.25rem"
          >
            <slot :name="!heroLeft || hasHeroStrategy ? 'title_right_after' : 'none'"></slot>
            <slot
              name="title_hero_after"
              :item="hero"
            >
            </slot>
          </div>
        </div>
        <div
          v-if="hasHero || hasHeroStrategy"
          ref="cont"
          class="trainer_ra_table hero"
          :class="`trainer_ra_table_${showPropHero}`"
          @click="handleTableClick"
          @mousedown="handleTableMousedown"
        >
          <div
            v-for="combos in tableGroups"
            :key="combos.id"
            class="trainer_rtc"
            :data-tst="`trainer_rtc_hero_${combos.id}`"
            :style="getHeroRtcStyle(combos)"
            :class="{
              trainer_rtc_active:
                learningMode || skeleton ? false : combos.id === comboHandGroup.group_id,
            }"
          >
            {{ combos.id }}
          </div>
          <div
            v-if="hasExpandOverlay"
            class="trainer_ra_table_expand"
            data-tst="trainer_ra_table_expand"
          >
            <i class="mdi mdi-arrow-expand text-big icon_btn icon_btn_active pa-2"></i>
          </div>
        </div>
        <div
          v-else
          class="trainer_ra_table_show"
        ></div>
      </div>
    </div>
    <div
      v-if="!hasHeroStrategy"
      class="traranges_player-container"
      :class="!heroLeft ? 'order_1' : 'order_3 traranges_table-title_right'"
    >
      <div class="traranges_table-container">
        <div
          class="traranges_table_title gw_hvr"
          :data-tst="`trainerRangesTable_opponent_title`"
          @click="$emit('opponent:click')"
        >
          {{ !opponent.position ? '' : $t(`players.${opponent.position}`) }}
          <div
            class="d-flex align-center ml-auto"
            style="gap: 0.25rem"
          >
            <slot :name="heroLeft ? 'title_right_after' : 'none'"></slot>
            <slot
              name="title_opponent_after"
              :item="opponent"
            >
            </slot>
          </div>
        </div>
        <div
          v-if="hasOpponent"
          ref="cont"
          class="trainer_ra_table opponent"
          :class="`trainer_ra_table_${showPropOpponent}`"
          @click="handleTableClick"
          @mousedown="handleTableMousedown"
        >
          <div
            v-for="combos in tableGroups"
            :key="combos.id"
            class="trainer_rtc"
            :data-tst="`trainer_rtc_opponent_${combos.id}`"
            :style="getRangeStyle(combos.players[1])"
          >
            {{ combos.id }}
          </div>
          <div
            v-if="hasExpandOverlay"
            class="trainer_ra_table_expand"
          >
            <i class="mdi mdi-arrow-expand text-big icon_btn icon_btn_active pa-2"></i>
          </div>
        </div>
        <div
          v-else
          class="trainer_ra_table_show"
        ></div>
      </div>
    </div>
    <div
      v-show="learningMode"
      class="traranges_dl-overlay"
    >
      <div
        class="mdi mdi-eye-off text-semi-large"
        style="margin-top: -0.5rem"
      ></div>
      {{ $t('messages.trainer_learning_mode_on') }}
    </div>
    <slot name="switcher"> </slot>
  </div>
</template>

<script>
import { getStrategyClrs, getComboMainGroup } from '@/helpers/solution'

export default {
  name: 'TrainerRangesTables',
  props: {
    hasHeroStrategy: Boolean,
    hasHero: Boolean,
    hasOpponent: Boolean,
    handInfo: Object,
    showPropHero: { default: 'strategy' },
    showPropOpponent: { default: 'range' },
    hero: Object,
    opponent: Object,
    heroLeft: Boolean,
    useHex: Boolean,
    learningMode: Boolean,
    hasExpandOverlay: Boolean,
    rangeKey: String,
    tableGroups: { default: [] },
    skeleton: Boolean,
  },
  emits: ['hero:click', 'opponent:click', 'table:click', 'table:mousedown'],
  data() {
    return {
      heroIndex: 0,
    }
  },
  methods: {
    handleTableClick() {
      this.$emit('table:click')
    },
    handleTableMousedown() {
      this.$emit('table:mousedown')
    },
    getHeroRtcStyle(group) {
      // console.log(group)
      if (this.hasHeroStrategy) {
        const { clrs_var, clrs_hex, size } = getStrategyClrs({
          solution: group.solution,
          range: group.players[this.heroIndex][this.rangeKey],
        })
        const style = `${
          group.players[this.heroIndex].range
            ? `--rtc-back-image: ${this.useHex ? clrs_hex : clrs_var};
           --rtc-back-size:${size};
           --clr-rtc-back: var(--clr-range_active);
           --clr-text: var(--clr-range_text);
          `
            : `
           --clr-text: var(--clr-black-6);
          `
        }`
        return style
      }
      return this.getRangeStyle(group.players[this.heroIndex])
    },
    getRangeStyle(player) {
      if (!player?.range) return ''
      if (this.rangeKey === 'range') {
        return `
         --opacity-range: ${player?.range || 0};
         --clr-rtc-back: var(--clr-range_active);
         --clr-text: ${player?.range ? 'var(--clr-white-0)' : 'var(--clr-black-6)'};`
      }
      return `--rtc-back-image: linear-gradient(var(--clr-range),var(--clr-range));
              --rtc-back-size: 100% ${player[this.rangeKey] * 100}%;
              --clr-rtc-back: var(--clr-range_active);
              --clr-text: ${player?.range ? 'var(--clr-white-0)' : 'var(--clr-black-6)'};`
    },
  },
  computed: {
    comboHandGroup() {
      return this.handInfo ? getComboMainGroup({ id: this.handInfo.hand }) : {}
    },
  },
}
</script>
<style lang="scss" scoped>
@media (max-width: 520px) {
  .traranges {
    --height: 50vw !important;
  }
}

.traranges {
  font-size: 1rem;
  display: flex;
  --grid-gap: 0.5rem;
  width: 100%;
  grid-gap: var(--grid-gap);
  --height: 9rem;
  position: relative;

  --clr-rtc-back: var(--clr-range_empty);

  &_player-container {
    position: relative;
    display: flex;
    height: var(--height);
    width: 100%;
  }
  &_single-table {
    .traranges_player-container {
      height: calc(var(--height) * 2);
      // --title-width: calc(100% - 3.75rem) !important;
    }
    .trainer_rtc_active {
      z-index: 2 !important;
      outline: none !important;
      box-shadow: 0px 0px 0px 2px var(--clr-trainer_hand_highlight);
      transform: scale(1.1);
      position: relative;
      border-radius: 4px;
      top: -0.5px;
      left: -0.5px;
      // &:after {
      //   content: '';
      //   z-index: 1;
      //   position: absolute;
      //   height: calc(100% - 4px);
      //   width: calc(100% - 4px);
      // }
    }
  }
  // &_table-title_right {
  // --title-width: calc(100% - 3.75rem) !important;
  // }
  &_table-container {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    right: 0;
    // --title-size: 1rem;
    --title-size: 0.875rem;
    --title-padding: 0;
  }
  &_learning-mode {
    .trainer_ra_table_expand {
      display: none;
    }
    .trainer_ra_table {
      .trainer_rtc {
        --opacity-range: 0 !important;
        --clr-rtc-back: var(--clr-black-1) !important;
        --rtc-back-size: 100% 100% !important;
        --rtc-back-image: linear-gradient(var(--clr-black-1), var(--clr-black-1)) !important;
        color: var(--clr-rtc-back) !important;
        text-shadow: none !important;
      }
      .trainer_rtc_active {
        z-index: 0 !important;
        &:after {
          display: none;
        }
      }
    }
  }
  --title-min-height: clamp(24px, 1.5em, 1.5rem);
  &_table {
    position: relative;
    &_title {
      border-radius: 4px;
      display: flex;
      align-items: center;
      min-height: var(--title-min-height);
      font-size: var(--title-size);
      padding: var(--title-padding);
      font-weight: 700;
      color: var(--clr-grey-2);
      position: relative;
      width: 100%;
      // width: var(--title-width);
      z-index: 1;
    }
  }
  &_dl-overlay {
    position: absolute;
    z-index: 1;
    top: var(--title-min-height);
    width: 100%;
    height: calc(100% - var(--title-min-height));
    background: rgba(0, 0, 0, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 1rem;
    text-align: center;
    font-weight: 500;
    color: var(--clr-grey-2);
  }
}

.trainer_ra_table {
  flex: 1;
  display: grid;
  flex-shrink: 0;
  grid-template-columns: repeat(13, 1fr);
  grid-template-rows: repeat(13, 1fr);
  // grid-gap: 1px;
  // overflow: hidden;
  border-radius: 4px;
  background: var(--clr-black-0);
  box-shadow: 0px 0px 0px 1px var(--clr-black-0);
  position: relative;
  // --clr-text: var(--clr-grey-2);
  .trainer_rtc {
    outline: 1px solid var(--clr-black-0);

    --opacity-range: 0;
    color: var(--clr-text);
    // color: var(--clr-range_text);
    background-color: var(--clr-rtc-back);
    background-image: var(--rtc-back-image);
    background-size: var(--rtc-back-size);
    background-repeat: no-repeat;
    background-position-y: 100%;
    min-height: 0.5rem;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    text-shadow: var(--text-shadow_drop_minimal);
    // &:not(.trainer_rtc_active) {
    --rtc-radius: 4px;
    &:nth-child(1) {
      border-top-left-radius: var(--rtc-radius);
      overflow: hidden;
    }
    &:nth-child(13) {
      border-top-right-radius: var(--rtc-radius);
      overflow: hidden;
    }
    &:nth-child(157) {
      border-bottom-left-radius: var(--rtc-radius);
      overflow: hidden;
    }
    &:nth-child(169) {
      border-bottom-right-radius: var(--rtc-radius);
      overflow: hidden;
    }
    // }
  }
  &_range {
    .trainer_rtc {
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: var(--opacity-range);
        background-color: var(--clr-range);
        z-index: -1;
      }
    }
  }
  &:hover {
    overflow: hidden;
    .trainer_ra_table_expand {
      opacity: 1;
    }
  }
  &_expand {
    transition: 0.22s;
    cursor: pointer;
    opacity: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.5);
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3;
    color: var(--clr-grey-2);
  }
  &_switcher {
    position: absolute;
    top: 0.5rem;
    width: 100%;
  }
  &_show {
    flex: 1;
    border-radius: 4px;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.33);
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    grid-gap: 0.5rem;
    color: var(--clr-white-0);
    transition: 0.22s;
    &:hover {
      background: rgba(0, 0, 0, 0.33);
    }
  }
}
</style>

<style lang="scss">
.trainer_ra_table {
  container-name: trainer_ra_table;
  container-type: size;
}
@container trainer_ra_table (max-width: 420px) {
  .trainer_rtc {
    font-size: clamp(4px, 3cqw, 1rem);
    // display: none !important;
  }
}

@container trainer_ra_table (max-width: 188px) {
  .trainer_rtc {
    font-size: 0;
    // display: none !important;
  }
}
</style>
